<template>
    <form action="" class="" v-on:submit.prevent="update">
        <FormErrors :errors="vuelidate.$errors" />
        <SelectInput placeholder="Destacados" :items="[{id:'0',name:'Ocultar'},{id:'1',name:'Mostrar'}]" :value="vuelidate.config.featured.$model" v-model="vuelidate.config.featured.$model" />
        <InputComponent v-if="vuelidate.config.featured.$model==1" type="text" placeholder="Titulo Destacados" :value="vuelidate.config.featuredTitle.$model" v-model="vuelidate.config.featuredTitle.$model" />
        <SelectInput placeholder="Blog" :items="[{id:'0',name:'Ocultar'},{id:'1',name:'Mostrar'}]" :value="vuelidate.config.blog.$model" v-model="vuelidate.config.blog.$model" />
        <div class="p-5 my-8 border rounded-2xl border-light_gray bg-light_yellow">
            <h3 class="text-xl font-bold text-enriqueto_green">Comparación geográfica</h3>
            <p class="mt-2 mb-4 text-sm text-gray">Control general para mostrar u ocultar esta sección en todas las páginas de productos.</p>
            <SelectInput
                placeholder="Comparación geográfica"
                :items="[{id:'0',name:'Ocultar en todo el sitio'},{id:'1',name:'Mostrar productos habilitados'}]"
                :value="vuelidate.config.regional_comparison_enabled.$model"
                v-model="vuelidate.config.regional_comparison_enabled.$model"
            />
        </div>
        <SubmitButtonComponent value="Guardar"/>
    </form>
</template>

<script>
import { ref } from '@vue/reactivity'
import SubmitButtonComponent from './SubmitButtonComponent.vue'
import FormErrors from './FormErrors.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import useApi from '../../Services/useApi'
import { Inertia } from '@inertiajs/inertia'
import useNotification from '../../Services/useNotification'
import SelectInput from './SelectInput.vue'
import InputComponent from './InputComponent.vue'

export default {
    components: { SubmitButtonComponent, FormErrors, SelectInput, InputComponent },
    props: ['config'],
    validations() {
        return {
            config: {
                featured: {
                    required
                },
                featuredTitle: {
                    required
                },
                blog: {
                    required
                },
                regional_comparison_enabled: {
                    required
                }
            },
        }
    },
    setup(props,{emit}){
        const vuelidate = useVuelidate();
        const api = useApi();
        const config= ref(props.config)
        const notificate = useNotification()

        const update = async()=>{
            let validation = await vuelidate.value.$validate();

            if(validation){
                api.updateConfig(config.value).then(response=>{
                    console.log(response)
                    notificate.success('Editado con exito')
                    Inertia.reload()
                    emit('added')
                })
            }else{
                notificate.error('Revisa el formulario')
            }
        }

        return{
            config,
            update,
            vuelidate
        }
    }
}
</script>

<style>

</style>
